import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import ConfigSolicitacaoCirurgiaStore, { ConfigSolicitacaoCirurgia, ConfigSolicitacaoCirurgiaDefault, ConfigSolicitacaoCirurgiaPorConvenio } from '@/components/Configuracoes/store/ConfigSolicitacaoCirurgiaStore'
import { getModule } from 'vuex-module-decorators'

@Component
export default class ComponentStepper extends Vue {
  @Prop() template: ConfigSolicitacaoCirurgia | ConfigSolicitacaoCirurgiaPorConvenio

  @Prop({ default: false }) canShowAssurances: boolean
  @Prop({ default: false }) canClone: boolean
  @Prop({ default: true }) canShowBackofficeStep: boolean

  get configSolicitacaoCirurgiaStore() { return getModule(ConfigSolicitacaoCirurgiaStore, this.$store) }

  get hospitalId() { return this.configSolicitacaoCirurgiaStore.hospitalId }
  set hospitalId(value: string) { this.configSolicitacaoCirurgiaStore.setHospitalId(value) }

  faixaDeCaracteres: Array<{ label: string; value: number | string }> = [
    { label: '40 caracteres', value: 40 },
    { label: '30 caracteres', value: 30 },
    { label: '20 caracteres', value: 20 },
    { label: '15 caracteres', value: 15 },
  ]

  intervalosDeTempo: Array<{ label: string; value: number | string }> = [
    { label: '30 minutos', value: 30 },
    { label: '15 minutos', value: 15 },
    { label: '10 minutos', value: 10 },
    { label: '5 minutos', value: 5 },
  ]

  cirurgiaConjuntaCampos: Array<{ key: string, label: string }> = [
    { key: 'tipoConselho', label: 'Tipo de conselho' },
    { key: 'uf', label: 'UF' },
    { key: 'numeroConselho', label: 'Número do conselho' },
    { key: 'nomeMedico', label: 'Nome do médico' },
    { key: 'especialidade', label: 'Especialidade' },
    { key: 'email', label: 'E-mail' },
  ]

  editFornecedorLabel: boolean = false
  editFornecedorButtonLabel: boolean = false
  editLaudoTitle: boolean = false
  editLaudoDesc: boolean = false
  editTermoDeConsentimentoTitle: boolean = false
  editTermoDeConsentimentoDesc: boolean = false
  editDocumentosDiversosTitle: boolean = false
  editDocumentosDiversosDesc: boolean = false
  editDocumentacaoPacienteTitle: boolean = false
  editDocumentacaoPacienteDesc: boolean = false
  editCaixaCirurgicaTitle: boolean = false
  editNumeroDoAtendimentoAoPacienteNoHospitalTitle: boolean = false
  editJustificativaTecnicaTitle: boolean = false

  assuranceRules = [v => (v && v.length > 0) || 'Campo obrigatório.']

  clearFields(f: string, v: boolean) {
    if (!v && ['anexos', 'documentacaoPaciente', 'documentosDiversos', 'termoDeConsentimento', 'opmes', 'caixaCirurgica', 'numeroDoAtendimentoAoPacienteNoHospital', 'justificativaTecnica'].includes(f)) {
      switch (f) {
        case 'opmes':
          this.editFornecedorLabel = false
          this.editFornecedorButtonLabel = false
          break
        case 'anexos':
          this.editLaudoTitle = false
          this.editLaudoDesc = false
          break
        case 'documentacaoPaciente':
          this.editDocumentacaoPacienteTitle = false
          this.editDocumentacaoPacienteDesc = false
          break
        case 'documentosDiversos':
          this.editDocumentosDiversosTitle = false
          this.editDocumentosDiversosDesc = false
          break
        case 'termoDeConsentimento':
          this.editTermoDeConsentimentoTitle = false
          this.editTermoDeConsentimentoDesc = false
          break
        case 'caixaCirurgica':
          this.editCaixaCirurgicaTitle = false
          break
        case 'numeroDoAtendimentoAoPacienteNoHospital':
          this.editNumeroDoAtendimentoAoPacienteNoHospitalTitle = false
          break
        case 'justificativaTecnica':
          this.editJustificativaTecnicaTitle = false
          break
        default:
          break
      }
    }

    this.configSolicitacaoCirurgiaStore.clearFields({ field: f, val: v, template: this.template })
  }

  assuranceChange() {
    this.validation()
  }

  onChangeAnestesiaHospitalCampos(value: boolean, field: string) {
    if (value && field !== 'hospitalUtilizaClinicasDeAnestesia' && this.template.anestesiaHospital.campos.hospitalUtilizaClinicasDeAnestesia) {
      this.template.anestesiaHospital.campos.hospitalUtilizaClinicasDeAnestesia = false
    }
    if (value && field === 'hospitalUtilizaClinicasDeAnestesia') {
      Object.entries(this.template.anestesiaHospital.campos).forEach(([key]) => {
        if (key !== 'hospitalUtilizaClinicasDeAnestesia') {
          this.template.anestesiaHospital.campos[key] = false
        }
      })
    }
  }

  onChangeHonorarioAnestesistaAutomatizado(value: boolean) {
    if (value && !this.template.honorarioAnestesista.campos.hospital) {
      this.template.honorarioAnestesista.campos.hospital = true
    }
  }

  onChangeHonorarioAnestesistaCampoHospital(value: boolean) {
    if (!value && this.template.honorarioAnestesista.automatizadoQuandoAnestesiaEhDoHospital) {
      this.template.honorarioAnestesista.automatizadoQuandoAnestesiaEhDoHospital = false
    }
  }

  @Emit()
  validation() {
    if (!this.canShowAssurances) {
      return true
    }

    const template = this.template as ConfigSolicitacaoCirurgiaPorConvenio
    if (template.convenioIds.length > 0) {
      return true
    }

    return false
  }

  cloneFromDefaultTemplate() {
    const defaultTemplateJson = JSON.stringify(this.configSolicitacaoCirurgiaStore.configSolicitacaoCirurgia)
    const defaultTemplate: ConfigSolicitacaoCirurgiaDefault = JSON.parse(defaultTemplateJson)
    defaultTemplate.porConvenios = undefined!
    Object.assign(this.template, defaultTemplate)
  }

  mounted() {
    this.validation()
  }

  documentoPrincipalChange(field: string, event: any) {
    switch (field) {
      case 'cpf':
        this.template.rgh.principal = !event
        break
      case 'rgh':
        this.template.cpf.principal = !event
        break
      default:
        break
    }
  }
}
